export default __webpack_public_path__ + "static/media/dog1.5aae5866.jpg";